import * as React from 'react';
import styled from 'styled-components';
export const CardWrapper = styled.div `
  display: block;
  width: 100%;
  background-color: ${props => props.theme.palette.white.main};
  box-shadow: 0 2px 4px 0 rgba(153, 171, 189, 0.4);
  border-radius: 4px;
  padding: ${({ padding }) => Number(padding)}px;
  overflow: ${({ overflow }) => overflow};
  // A card in a card should not have any box shadow
  ${() => CardWrapper} {
    box-shadow: none;
  }
  .match-height {
    height: 100%;
  }
`;
export class Card extends React.PureComponent {
    render() {
        return React.createElement(CardWrapper, Object.assign({}, this.props));
    }
}
Card.defaultProps = {
    padding: 0,
    overflow: 'hidden',
};
//# sourceMappingURL=index.js.map